import React from 'react';
import PropTypes from 'prop-types';
import {
  IonLabel,
  IonText,
  IonRow,
  IonCol
} from '@ionic/react';
import { Card } from '@tremor/react';

const SmsPlans = ({
  smsAmount,
  onSmsAmountChange,
  errors
}) => {

  return (
    <IonRow className="ion-margin-top">
      <IonCol size="12">
        <Card
          style={{
            borderRadius: '10px',
            padding: '1rem',
          }}
        >
          <IonText>
            <p className="ion-margin-bottom">
              Enter SMS amount you wish to purchase. 1 SMS is equal to 1 KES
            </p>
          </IonText>

          <div>
            <IonLabel position="stacked">SMS Amount</IonLabel>
            <input
              type="number"
              id="smsAmount"
              name="smsAmount"
              value={smsAmount || ''}
              onChange={onSmsAmountChange}
              placeholder="Enter SMS amount"
              className="form-control"
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '16px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                backgroundColor: 'white',
                color: 'black'
              }}
            />
          </div>

          {errors.smsAmount && (
            <IonText color="danger">
              <small>{errors.smsAmount}</small>
            </IonText>
          )}
        </Card>
      </IonCol>
    </IonRow>
  );
};

SmsPlans.propTypes = {
  smsAmount: PropTypes.string.isRequired,
  onSmsAmountChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    smsAmount: PropTypes.string
  }).isRequired
};

export default SmsPlans;
